<div class="modal-background" bdFxLayoutAlign="center start">
    <div class="projects-modal">
        <div class="header">
            <div class="title">
                Änderungshistorie
            </div>
            <div class="save">
                <bd-fa-button [name]="'times'" (click)="onCancelBtnClicked()"></bd-fa-button>
            </div>
        </div>

        <div class="body">
            <div class="table">
                <div class="table-header">
                    <div>Zeitpunkt</div>
                    <div>Name</div>
                    <div>Änderung</div>
                </div>
                <div class="table-body">
                    <div class="table-row" *ngFor="let historyEvent of model.basicHistory">
                        <div>{{historyEvent.lastUpdate | date:'dd.MM.yyyy'}}</div>
                        <div>{{historyEvent.modifiedBy}}</div>
                        <div>{{changeHistoryBasicTypeEnum[historyEvent.type]}}</div>
                    </div>
                </div>

            </div>
        </div>


    </div>
</div>
